import { scheduleLazyScript } from "~/layers/base/utils/scheduleLazyScript";

const CLARITY_SCRIPT_ID = "ms-clarity";
const CLARITY_PROJECT_ID = "vi8qrtkn7g";
const CLARITY_SCRIPT_SRC = `https://www.clarity.ms/tag/${CLARITY_PROJECT_ID}`;

type ClarityFn = ((...args: unknown[]) => void) & { q?: unknown[][] };
type ClarityWindow = Window & {
	clarity?: ClarityFn;
};

export default defineNuxtPlugin(() => {
	const w = window as ClarityWindow;

	// Queue stub so `clarity(...)` calls before the script loads aren't lost.
	if (!w.clarity) {
		const stub: ClarityFn = function (...args: unknown[]) {
			(stub.q = stub.q || []).push(args);
		};
		w.clarity = stub;
	}

	const injectClarity = () => {
		if (document.getElementById(CLARITY_SCRIPT_ID)) {
			return;
		}

		const script = document.createElement("script");
		script.id = CLARITY_SCRIPT_ID;
		script.src = CLARITY_SCRIPT_SRC;
		script.async = true;

		document.head.appendChild(script);
	};

	// Microsoft Clarity is analytics/marketing tracking — only inject after the
	// user grants marketing consent (AGENTS.md rule #4).
	useMarketingConsent(() => scheduleLazyScript(injectClarity));
});
